"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CheckIcon = function CheckIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: 9,
    height: 9,
    viewBox: "0 0 8 6"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.225 4.877c-.687-.686.357-1.73 1.043-1.044L2.596 5.16l4.136-4.135c.686-.687 1.73.357 1.043 1.044L3.118 6.726c-.289.289-.756.289-1.044 0L.224 4.877z",
    transform: "translate(-1105 -366) translate(0 63) translate(265 17) translate(0 237) translate(830 11) translate(0 27) translate(1 6) translate(9 4)"
  })));
};

var _default = CheckIcon;
exports["default"] = _default;